import { createContext, useContext } from 'react';

export const SiteDataContext = createContext({});
export const useSiteData = () => useContext(SiteDataContext);

export function readSiteData() {
  const element = document.getElementById('site-data');
  if (!element) return {};
  try { return JSON.parse(element.textContent); } catch { return {}; }
}
